/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

//  Phaser.Physics.Impact.Body.Components

module.exports = {

    Acceleration: require('./Acceleration'),
    BodyScale: require('./BodyScale'),
    BodyType: require('./BodyType'),
    Bounce: require('./Bounce'),
    CheckAgainst: require('./CheckAgainst'),
    Collides: require('./Collides'),
    Debug: require('./Debug'),
    Friction: require('./Friction'),
    Gravity: require('./Gravity'),
    Offset: require('./Offset'),
    SetGameObject: require('./SetGameObject'),
    Velocity: require('./Velocity')

};



//////////////////
// WEBPACK FOOTER
// ./physics/impact/components/index.js
// module id = 159
// module chunks = 0